import React, { Fragment, useContext } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useTranslate } from 'react-polyglot'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import ROUTES from 'constants/routes'
import ENTITY from 'constants/entities'
import {
    ALERT_TYPES,
    BUTTON_STATUS,
    BUTTON_TYPE,
    INPUT_FILED_TYPE,
} from 'constants/enums'

import { loginService } from 'services/auth.service'
import { getEntityByIdService } from 'services/entity.service'

import { AlertContext } from 'contexts/AlertContext'
import { CurrentUserContext } from 'contexts/CurrentUserContext'

import InputField from 'components/formFields/InputField'
import Button from 'components/Button'
import Loader from 'components/Loader'

const Login = () => {
    const t = useTranslate()
    const navigate = useNavigate()

    const { setAlert } = useContext(AlertContext)
    const { setCurrentUser } = useContext(CurrentUserContext)

    const handleSubmit = async (formData, { setSubmitting }) => {
        try {
            setSubmitting(true)
            const loginData = await loginService(formData)
            const { user_id } = loginData
            if (user_id) {
                const data = await getEntityByIdService(ENTITY.USER, user_id, {
                    include: 'role,setting,group,superVisorGroup',
                })
                setCurrentUser(data)
                navigate(ROUTES.HOME)
            }
            setSubmitting(false)
        } catch (error) {
            setSubmitting(false)
            if (error?.response?.data?.canUnban) {
                setAlert(t('message.userBanned'), ALERT_TYPES.ERROR)
                navigate(ROUTES.UNBAN)
            } else {
                setAlert(error, ALERT_TYPES.ERROR)
            }
        }
    }

    const initialValues = {
        username: '',
        password: '',
    }

    const requiredMessage = t('form.error.required')

    const validation = Yup.object({
        username: Yup.string().required(requiredMessage),
        password: Yup.string().required(requiredMessage),
    })

    return (
        <Fragment>
            <div className="m-noAuth__form">
                <div className="m-noAuth__logo"></div>
                <div className="m-form -login">
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validation}
                        onSubmit={handleSubmit}
                    >
                        {({ isSubmitting }) => (
                            <Form>
                                <InputField
                                    name="username"
                                    type={INPUT_FILED_TYPE.TEXT}
                                    label="form.label.username"
                                    placeholder="form.label.username"
                                    icon="user"
                                    required
                                />
                                <InputField
                                    name="password"
                                    type={INPUT_FILED_TYPE.PASSWORD}
                                    label="form.label.password"
                                    placeholder="form.label.password"
                                    icon="lock"
                                    required
                                />
                                <Button
                                    btnClass={BUTTON_STATUS.PRIMARY}
                                    type={BUTTON_TYPE.SUBMIT}
                                    label="button.login"
                                />
                                {isSubmitting && <Loader />}
                            </Form>
                        )}
                    </Formik>
                    <span className="m-form__links">
                        <Link
                            to={ROUTES.FORGOT_PASSWORD}
                            className="m-form__link -secondary"
                        >
                            {t('links.forgotPassword')}
                        </Link>
                        <Link
                            to={ROUTES.REGISTER}
                            className="m-form__link -primary"
                        >
                            {t('links.register')}
                        </Link>
                    </span>
                </div>
            </div>
            <div className="m-noAuth__formAuthMessage">
                {t('general.loginAuthMessage')}
            </div>
        </Fragment>
    )
}

export default Login
